export const richTextToPlain = (value: string): string => {
  if (!value?.trim()) return '';
  try {
    const blocks = JSON.parse(value) as { content?: { text?: string }[]; children?: unknown[] }[];
    return blocks
      .map(b => (b.content ?? []).map(c => c.text ?? '').join(''))
      .join(' ')
      .trim();
  } catch {
    return '';
  }
};
